module.exports = __webpack_public_path__ + "img/home_product_bg.5953c7d6.png";